import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages } from 'react-intl'
import { connect } from 'react-redux'

import upgradeCommandCenter, { closeConfirmation } from 'state/actions/command_center_upgrade'

import { COMMAND_CENTER_TITLE } from 'helpers/i18n.jsx'

import UpgradeConfirmationView from 'components/UpgradeConfirmationView/UpgradeConfirmationView.jsx'
import { formatMessage } from 'locale'

export const commandCenterMessages = defineMessages({
    buildingName: {
        id: 'command_center.notification_title',
        defaultMessage: 'Командный центр',
    },
})

export class UpgradeConfirmation extends React.Component {
    static propTypes = {
        level: PropTypes.number.isRequired,
        upgraded: PropTypes.bool.isRequired,
        upgradeCost: PropTypes.number.isRequired,
        upgradeCommandCenter: PropTypes.func.isRequired,
        cancelUpgradeHandler: PropTypes.func.isRequired,
    }

    componentWillMount() {
        this.currentLevel = this.props.level
    }

    getBuildingName() {
        return formatMessage(commandCenterMessages.buildingName)
    }

    render() {
        const { level } = this.props
        const buildingName = this.getBuildingName()
        const submitHandler = this.props.upgradeCommandCenter.bind(null, level + 1, buildingName)
        const cancelHandler = this.props.cancelUpgradeHandler

        return (
            <UpgradeConfirmationView
                type='COMMAND_CENTER'
                name={COMMAND_CENTER_TITLE}
                level={this.currentLevel}
                upgraded={this.props.upgraded}
                upgradeCost={this.props.upgradeCost}
                submitHandler={submitHandler}
                cancelHandler={cancelHandler}
            />
        )
    }
}

export const mapStateToProps = ({ settings, stronghold, commandCenterUpgrade }) => ({
    upgradeCost: settings.command_center.costs[stronghold.level],
    level: stronghold.level,
    upgraded: commandCenterUpgrade.submitted,
})

const mapDispatchToProps = {
    upgradeCommandCenter,
    cancelUpgradeHandler: closeConfirmation,
}

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeConfirmation)



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/UpgradeConfirmation/UpgradeConfirmation.jsx